import dayjs from 'dayjs';

const addDays = (date: Date | string, days: number): string =>
  dayjs(date)
    .add(days || 0, 'day')
    .toISOString();

export default addDays;
